import * as React from 'react'

import {
  FirstName,
  FormGroup,
  LastName,
  PhoneNumberInput as PhoneNumber,
  Text,
} from '@grandvisionhq/forms'
import type { FormSlotType } from '@grandvisionhq/lib-form-slots'
import { useIntl } from '@grandvisionhq/state'

import { INTL_DEFAULTS } from '../../../configuration/intl'
import { countriesOrder } from '../../../configuration/phone-number-input'
import { isIvaCode } from '../../../util/form-validation'
import { FormProps } from '../types'

const PersonalDetailsForm: FormSlotType<FormProps> = () => {
  const { getLabel } = useIntl()

  return (
    <React.Fragment>
      <FormGroup columns={2}>
        <FirstName
          label={getLabel('checkout.contact.firstName')}
          errorMessage={getLabel('checkout.contact.firstName.errorMessage')}
        />
        <LastName
          label={getLabel('checkout.contact.lastName')}
          errorMessage={getLabel('checkout.contact.lastName.errorMessage')}
        />
      </FormGroup>
      <Text
        id="ssn"
        data-t="customer-vat-id"
        label={getLabel('checkout.contact.nif')}
        tooltip={getLabel('checkout.contact.nif.hint')}
        validations={[isIvaCode]}
        errorMessage={getLabel('checkout.contact.nif.errorMessage')}
        optionalText={getLabel('checkout.form.field.optional')}
      />
      <PhoneNumber
        id="phone"
        data-t="phone-number"
        label={getLabel('checkout.contact.phoneNumber')}
        required
        hideAsteriskSign={false}
        initialState={{
          value: '',
        }}
        defaultCountry={INTL_DEFAULTS.country}
        localeForTranslations={INTL_DEFAULTS.locale}
        countriesOrder={countriesOrder}
        errorMessage={getLabel('checkout.contact.phoneNumber.errorMessage')}
        optionalText={getLabel('checkout.form.field.optional')}
      />
    </React.Fragment>
  )
}

export default PersonalDetailsForm
